import { RadioButtonItem } from 'ui';

export const nonUsPersonRadioItems: RadioButtonItem[] = [
  {
    label: 'Exempt Beneficial Owner (includes self-managed superannuation fund)',
    value: 'exempt',
    description:
      'This applies to organisations like government entities, international organisations, or retirement funds that are automatically exempt from certain tax reporting requirements. For example, a government agency or a self-managed superannuation fund in Australia might fall into this category.',
  },
  {
    label: 'Active Non-Financial Entity (Non U.S.)',
    value: 'active',
    description:
      'This refers to a business or entity that earns most of its income from actual business operations rather than passive income like dividends or investments. For example, a company selling products or providing services.',
  },
  {
    label: 'Passive Non-Financial Entity (Non U.S.)',
    value: 'passive',
    description:
      'This refers to entities that earn most of their income from passive sources like dividends, interest, or rental income. An investment holding company would fit this category.',
  },
  {
    label: 'Direct Reporting Non-Financial Entity (Non U.S.)',
    value: 'direct',
    description:
      'This is for entities that report their financial information directly to the IRS (U.S. tax authority) instead of through another financial institution.',
  },
  {
    label: 'Participating Foreign   Financial Institution',
    value: 'participating',
    description:
      'A financial institution (like a bank) that has agreed to comply with U.S. tax reporting rules under FATCA (Foreign Account Tax Compliance Act).',
  },
  {
    label: 'Local/Partner Jurisdiction Foreign Financial Institution',
    value: 'local',
    description:
      'A financial institution operating in a country that has entered into a FATCA agreement with the U.S. and complies with local regulations tied to that agreement.',
  },
  {
    label: 'Deemed-Compliant Foreign Financial Institution.',
    value: 'deemed',
    description:
      'A financial institution that meets specific conditions under FATCA and is treated as compliant without needing to report extensively to the IRS. For example, small local banks.',
  },
  {
    label: 'Nonparticipating Foreign Financial Institution',
    value: 'nonparticipating',
    description:
      'A financial institution that has chosen not to comply with FATCA rules. As a result, these institutions may face withholding taxes on certain U.S. payments.',
  },
  {
    label: 'Sponsored Direct Reporting Non-Financial Entity (Non U.S.)',
    value: 'sponsored',
    description:
      'This is for entities that have a sponsor (like a financial institution) handling FATCA reporting on their behalf.',
  },
  {
    label: 'Other – describe the FATCA status',
    value: 'other',
    description:
      'If none of the above categories fit, you can describe your specific situation and status related to FATCA compliance.',
  },
];
